//USER
export const userLoginPath = () => '/api/user/login';
export const userAddPath = () => '/api/user/create';
export const userUpdatePath = () => `/api/user/update`;
export const userFindByIdPath = (id) => `/api/user/findById/${id}`;
export const userFindAllPath = () => `/api/user/findAll`;
export const userDeletePath = (id) => `/api/user/delete/${id}`;
export const userDeactivatePath = (id) => `/api/user/deactivate/${id}`;
export const userActivatePath = (id) => `/api/user/activate/${id}`;
export const userFindAllPageablePath = (pageNumber, pageSize, filters) =>
  `/api/user/findAllUsersFilteredAndPageable/${pageNumber}/${pageSize}?queryFilters=${encodeURIComponent(
    JSON.stringify(filters)
  )}`;
export const userChangePasswordPath = () => '/api/user/changePassword';
export const userRegistrationPath = () => '/api/user/register';
export const userUpdateWithSignaturePath = () => `/api/user/update-with-signature`;
export const userFindByIdWithSignaturePath = (id) => `/api/user/findByIdWithSignature/${id}`;

//USER ROLES
export const userRoleAddPath = () => '/api/role/create';
export const userRoleUpdatePath = () => `/api/role/update`;
export const userRoleFindByIdPath = (id) => `/api/role/c/${id}`;
export const userRoleFindAllPath = () => `/api/role/findAll`;
export const userRoleDeletePath = (id) => `/api/role/delete/${id}`;
export const userRoleFindAllPageablePath = (pageNumber, pageSize, filters) =>
  `/api/role/findAllRolesFilteredAndPageable/${pageNumber}/${pageSize}?queryFilters=${encodeURIComponent(
    JSON.stringify(filters)
  )}`;

  //BRAND
export const brandAddPath = () => '/api/brand/create';
export const brandUpdatePath = () => `/api/brand/update`;
export const brandFindByIdPath = (id) => `/api/brand/c/${id}`;
export const brandFindAllPath = () => `/api/brand/findAll`;
export const brandDeletePath = (id) => `/api/brand/delete/${id}`;
export const brandFindAllPageablePath = (pageNumber, pageSize, filters) =>
  `/api/brand/findAllBrandsFilteredAndPageable/${pageNumber}/${pageSize}?queryFilters=${encodeURIComponent(
    JSON.stringify(filters)
  )}`;
  //VEHICLE MODEL
export const vehicleModelAddPath = () => '/api/vehiclemodel/create';
export const vehicleModelUpdatePath = () => `/api/vehiclemodel/update`;
export const vehicleModelFindByIdPath = (id) => `/api/vehiclemodel/c/${id}`;
export const vehicleModelFindAllPath = () => `/api/vehiclemodel/findAll`;
export const vehicleModelDeletePath = (id) => `/api/vehiclemodel/delete/${id}`;
export const vehicleModelFindAllPageablePath = (pageNumber, pageSize, filters) =>
  `/api/vehiclemodel/findAllModelsFilteredAndPageable/${pageNumber}/${pageSize}?queryFilters=${encodeURIComponent(
    JSON.stringify(filters)
  )}`;
export const vehicleModelFindByBrandIdPath = (id) => `/api/vehiclemodel/findByBrandId/${id}`;

   //VEHICLE 
export const vehicleAddPath = () => '/api/vehicle/create';
export const vehicleUpdatePath = () => `/api/vehicle/update`;
export const vehicleFindByIdPath = (id) => `/api/vehicle/c/${id}`;
export const vehicleFindAllPath = () => `/api/vehicle/findAll`;
export const vehicleDeletePath = (id) => `/api/vehicle/delete/${id}`;
export const vehicleFindAllPageablePath = (pageNumber, pageSize, filters) =>
  `/api/vehicle/findAllVehiclesFilteredAndPageable/${pageNumber}/${pageSize}?queryFilters=${encodeURIComponent(
    JSON.stringify(filters)
  )}`;

//PRODUCT CATEGORY
export const productCategoryAddPath = () => '/api/productCategory/create';
export const productCategoryUpdatePath = () => '/api/productCategory/update';
export const productCategoryFindAllPath = () => '/api/productCategory/findAll';
export const productCategoryFindByIdPath = (id) =>
  `/api/productCategory/findById/${id}`;
export const productCategoryDeletePath = (id) =>
  `/api/productCategory/delete/${id}`;
export const productCategoryFindAllPageablePath = (
  pageNumber,
  pageSize,
  filters
) =>
  `/api/productCategory/findAllProductCategoriesFilteredAndPageable/${pageNumber}/${pageSize}?queryFilters=${encodeURIComponent(
    JSON.stringify(filters)
  )}`;

//PRODUCT
export const productAddPath = () => '/api/product/create';
export const productUpdatePath = () => '/api/product/update';
export const productFindAllPath = () => '/api/product/findAll';
export const productFindByIdPath = (id) => `/api/product/findById/${id}`;
export const productDeletePath = (id) => `/api/product/delete/${id}`;
export const productFindAllPageablePath = (pageNumber, pageSize, filters) =>
  `/api/product/findAllProductsFilteredAndPageable/${pageNumber}/${pageSize}?queryFilters=${encodeURIComponent(
    JSON.stringify(filters)
  )}`;
export const productFindByIdWithLogoPath = (id) =>
  `/api/product/findByIdWithLogo/${id}`;
export const productUpdateWithLogoPath = () => `/api/product/update-with-logo`;
export const productLogoPath = (uuid) => `/api/product/logo/${uuid}`;

//TRAVEL ORDER
export const travelOrderAddPath = () => '/api/travel-order/create';
export const travelOrderUpdatePath = () => `/api/travel-order/update`;
export const travelOrderFindByIdPath = (id) => `/api/travel-order/c/${id}`;
export const travelOrderFindAllPath = () => `/api/travel-order/findAll`;
export const travelOrderDeletePath = (id) => `/api/travel-order/delete/${id}`;
export const travelOrderFindAllPageablePath = (pageNumber, pageSize, filters) =>
  `/api/travel-order/findAllTravelOrdersFilteredAndPageable/${pageNumber}/${pageSize}?queryFilters=${encodeURIComponent(
    JSON.stringify(filters)
  )}`;
  export const travelOrderDownloadPath = (id) => `/api/travel-order/download/${id}`;